<template>
    <td-dialog
        v-dialogDrag
        :title="$t(title)"
        :before-close="associtionListDlgClose"
        :visible.sync="dialogassocitionListVisible"
        width="1200px"
        @cancel="associtionListDlgClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <dialog-RelatedSet
            v-if="dialogRelatedSetVisible"
            :isAddData="isAddData"
            :dialogRelatedSetVisible="dialogRelatedSetVisible"
            :editItem="editItem"
            :listProInfo="listProInfo"
            :listCsmInfo="listCsmInfo"
            :title="title"
            @relatedSetDlgClose="relatedSetDlgClose"
            @submit="submit"
        ></dialog-RelatedSet>
        <el-row class="paddingTop10 marginBottom20">
            <el-col>
                <td-table
                    :columns="columns"
                    :dataSource="gridData"
                    :hasMutiSelect="false"
                    :pageSize="pageSize"
                    :currentPage="currentPage"
                    :total="total"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentChange"
                    height="500px"
                    :cell-class-name="cellClassName"
                ></td-table>
            </el-col>
        </el-row>
    </td-dialog>
</template>
<script>
import queueApi from '../assets/api.js';
import dialogRelatedSet from '../components/dialogRelatedSet.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-RelatedSet': dialogRelatedSet
    },
    props: ['title', 'dialogassocitionListVisible', 'associtionListData'],

    // 定义数据
    data() {
        return {
            cellClassName: 'cellStyle',
            gridData: [],
            listProInfo: [], // 生产者集合
            listCsmInfo: [], // 消费者集合
            dialogRelatedSetVisible: false,
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            spanArr: [],
            columns: [
                {
                    prop: 'sProducerResourceStr',
                    label: this.$t('common.PRODUCER'),
                    align: 'center'
                },
                {
                    prop: 'sChannelName',
                    label: this.$t('common.QUEUE_NAME'),
                    align: 'center'
                },
                {
                    prop: 'sConsumeResourceStr',
                    label: this.$t('common.CONSUMER'),
                    align: 'center'
                }
            ]
        };
    },
    created() {
        this.queryRelationsInfo();
    },
    methods: {
        // 查询数据，暂无数据查询接口
        queryRelationsInfo() {
            let param = {
                isPage: true,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            var _this = this;
            queueApi.queryRelationsInfo(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    _this.loading = false;
                    _this.$log.error('dialogAssocitionList/queryRelationsInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    _this.$log.error('dialogAssocitionList/queryRelationsInfo', response.data.message);
                    _this.loading = false;
                    return;
                }
                _this.gridData = response.data.content;
                _this.total = response.data.count;
            });
        },
        // 关闭关联列表窗口之前需要调用的方法
        associtionListDlgClose() {
            this.$emit('associtionListDlgClose');
        },
        // 关闭关联设置页面
        relatedSetDlgClose() {
            this.dialogRelatedSetVisible = false;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryRelationsInfo();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryRelationsInfo();
        }
    }
};
</script>
<style>
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
/*
element table 组件内容换行方案  pre-line 合并空白符序列，保留换行符。
*/
.cellStyle .cell {
    vertical-align: middle;
    white-space: pre-line !important;
}
</style>
